import React from "react";
import { Element } from "react-scroll";
import { APIProvider, Map } from "@vis.gl/react-google-maps";

const MapSection = () => {
  var mapOptions = {
    // How zoomed in you want the map to start at (always required)
    zoom: 11,
    // Disables the default Google Maps UI components
    disableDefaultUI: true,
    scrollwheel: false,
    draggable: true,

    // How you would like to style the map.
    // This is where you would paste any style found on Snazzy Maps.
    styles: [
      {
        featureType: "water",
        elementType: "geometry.fill",
        stylers: [{ color: "#d3d3d3" }],
      },
      {
        featureType: "transit",
        stylers: [{ color: "#808080" }, { visibility: "off" }],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [{ visibility: "on" }, { color: "#b3b3b3" }],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [{ color: "#ffffff" }],
      },
      {
        featureType: "road.local",
        elementType: "geometry.fill",
        stylers: [{ visibility: "on" }, { color: "#ffffff" }, { weight: 1.8 }],
      },
      {
        featureType: "road.local",
        elementType: "geometry.stroke",
        stylers: [{ color: "#d7d7d7" }],
      },
      {
        featureType: "poi",
        elementType: "geometry.fill",
        stylers: [{ visibility: "on" }, { color: "#ebebeb" }],
      },
      {
        featureType: "administrative",
        elementType: "geometry",
        stylers: [{ color: "#a7a7a7" }],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry.fill",
        stylers: [{ color: "#ffffff" }],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry.fill",
        stylers: [{ color: "#ffffff" }],
      },
      {
        featureType: "landscape",
        elementType: "geometry.fill",
        stylers: [{ visibility: "on" }, { color: "#efefef" }],
      },
      {
        featureType: "road",
        elementType: "labels.text.fill",
        stylers: [{ color: "#696969" }],
      },
      {
        featureType: "administrative",
        elementType: "labels.text.fill",
        stylers: [{ visibility: "on" }, { color: "#737373" }],
      },
      {
        featureType: "poi",
        elementType: "labels.icon",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "poi",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry.stroke",
        stylers: [{ color: "#d6d6d6" }],
      },
      {
        featureType: "road",
        elementType: "labels.icon",
        stylers: [{ visibility: "off" }],
      },
      {},
      {
        featureType: "poi",
        elementType: "geometry.fill",
        stylers: [{ color: "#dadada" }],
      },
    ],
  };
  return (
    <Element name="map">
      <div style={{ height: "100vh", width: "100%" }}>
        <APIProvider apiKey={"AIzaSyAEcAddHrOG47Rs-1p0BUa15wrGHWsGSF4"}>
          <Map
            style={{ width: "100vw", height: "100vh" }}
            defaultCenter={{ lat: 42.0363319, lng: -73.3764081 }}
            defaultZoom={15}
            gestureHandling={"cooperative"}
            disableDefaultUI={true}
            mapId="739af084373f96fe"
          ></Map>
        </APIProvider>
      </div>

      <div className="relative w-screen border-t-2 border-lightBlue">
       
        <div className="cursor-pointer">
          <a
            target="_blank"
            href="https://www.google.com/maps/place/O'Hara's+Landing+Marina/@42.0363319,-73.3764081,18z/data=!4m6!3m5!1s0x89e77c01fd549575:0xb07a7498b03cd1e2!8m2!3d42.0363299!4d-73.3751206!16s%2Fg%2F1tf7t4v3?entry=ttu&g_ep=EgoyMDI1MDQyMy4wIKXMDSoASAFQAw%3D%3D"
            className=" bg-black flex justify-center items-center px-12 py-3 text-sm font-bold text-white "
          >
            <div className=" w-auto">
              Get Directions
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="size-4 inline ml-2"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M13.5 6H5.25A2.25 2.25 0 0 0 3 8.25v10.5A2.25 2.25 0 0 0 5.25 21h10.5A2.25 2.25 0 0 0 18 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"
                />
              </svg>
            </div>
          </a>
        </div>
      </div>
    </Element>
  );
};

export default MapSection;
